import { render, staticRenderFns } from "./PopularTagsSection.vue?vue&type=template&id=4d0058d6&scoped=true&"
import script from "./PopularTagsSection.vue?vue&type=script&lang=js&"
export * from "./PopularTagsSection.vue?vue&type=script&lang=js&"
import style0 from "./PopularTagsSection.vue?vue&type=style&index=0&id=4d0058d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0058d6",
  null
  
)

export default component.exports